import { render, staticRenderFns } from "./ModalProdutoDescricao.vue?vue&type=template&id=1c12dc69&scoped=true&"
import script from "./ModalProdutoDescricao.vue?vue&type=script&lang=js&"
export * from "./ModalProdutoDescricao.vue?vue&type=script&lang=js&"
import style0 from "./ModalProdutoDescricao.vue?vue&type=style&index=0&id=1c12dc69&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c12dc69",
  null
  
)

export default component.exports